var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOutMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,41c0,1.6542969-1.3457031,3-3,3H11c-1.6542969,0-3-1.3457031-3-3V7c0-1.6542969,1.3457031-3,3-3h18 c1.6542969,0,3,1.3457031,3,3v7h2V7c0-2.7568359-2.2431641-5-5-5H11C8.2431641,2,6,4.2431641,6,7v34c0,2.7568359,2.2431641,5,5,5 h18c2.7568359,0,5-2.2431641,5-5v-7h-2V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,21.5859375l-7.2929688-7.2929688l-1.4140625,1.4140625L43.5859375,23H14v2h29.5859375l-7.2929688,7.2929688 l1.4140625,1.4140625L45,26.4140625C45.6445312,25.7695312,46,24.9121094,46,24S45.6445312,22.2304688,45,21.5859375z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutMedium);
export default __webpack_public_path__ + "static/media/log-out--medium.8a3c23dd2b55087961c7e12575a7c25c.svg";
export { ForwardRef as ReactComponent };